export function similarity(s1, s2) {
  let longer = s1;
  let shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  const longerLength = longer.length;
  if (longerLength === 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

/*
 * Track the highest number of matching words
 */
export function similarityByWords(arrayToSearch, nameSearch) {
  let highestMatchCount = 0;
  let phraseBySimilarity = null;

  arrayToSearch.forEach(url => {
    const urlName = url.toLowerCase().split('/').pop().split('.')[0];
    const searchWords = nameSearch.toLowerCase().split(' ');
    const urlWords = urlName.split('-').join(' ').split(' '); // Adjusted splitting logic for your URLs

    let matchCount = searchWords.reduce((count, word) => {
      return count + (urlWords.includes(word) ? 1 : 0);
    }, 0);

    //console.log("urlName", urlName);
    //console.log("matchCount", matchCount);
    if (matchCount > highestMatchCount) {
      phraseBySimilarity = url;
      highestMatchCount = matchCount;
    }
  });

  return phraseBySimilarity
}

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  const costs = [];
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) costs[j] = j;
      else {
        if (j > 0) {
          let newValue = costs[j - 1];
          if (s1.charAt(i - 1) !== s2.charAt(j - 1)) newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}

export const isSqftPassedDataEmpty = (sqftPassedData) => {
  if (sqftPassedData && sqftPassedData.manualCalculate === false) {
    return sqftPassedData.countertops.length === 0
  } else if (sqftPassedData && sqftPassedData.manualCalculate === true) {
    return sqftPassedData.countertops.length === 0
      || sqftPassedData.backsplashes.length === 0
      || sqftPassedData.edges.length === 0
  }
  return false
}

// Function to group URLs by version and sort them in descending order by version number
export function groupUrlsByVersion(urls) {
  // Create an array to store versioned URLs
  const versionedUrls = [];

  urls.forEach(url => {
    // Extract the version number from the URL (if present)
    const versionMatch = url.match(/ar-composer(?:-v(\d+))?/);
    // If no version is present, default to version 1
    const version = versionMatch && versionMatch[1] ? parseInt(versionMatch[1], 10) : 1;

    // Add the version and URL to the array as an object
    versionedUrls.push({ version, url });
  });

  // Sort the array by version in descending order
  versionedUrls.sort((a, b) => b.version - a.version);

  // Return an array of sorted URLs based on version
  return versionedUrls.map(item => item.url);
}
